"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _propTypes = _interopRequireDefault(require("@styled-system/prop-types"));

var _propTypes2 = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _draftjsToBbcode = _interopRequireDefault(require("draftjs-to-bbcode"));

var _draftJs = require("draft-js");

var _styles = require("./styles");

var _addLinkPlugin = _interopRequireDefault(require("./commonPlugins/addLinkPlugin"));

var _Typography = require("../Typography");

require("../../assets/vendors/css/draft.css");

var _Icons = require("../Icons");

var _Icon = require("../Icon");

var _ProgressBar = require("../ProgressBar");

var _Image = require("../Image");

var _Loader = require("../Loader");

var _Layout = require("../Layout");

var _Buttons = require("../Buttons");

var _Modal = require("../../molecules/Modal");

var _MenuContentItem = require("../../molecules/Menu/MenuContentItem");

var _functions = require("./functions");

var _textUtils = require("../../utils/textUtils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var FormContext = _react.default.createContext();

var Form = function Form(props) {
  var children = props.children,
      _onSubmit = props.onSubmit,
      name = props.name,
      id = props.id,
      autoComplete = props.autoComplete;
  return _react.default.createElement(FormContext.Provider, null, _react.default.createElement(_styles.FormStyled, (0, _extends2.default)({
    id: id,
    name: name,
    autoComplete: autoComplete,
    onSubmit: function onSubmit() {
      return _onSubmit();
    }
  }, props), children));
};

exports.Form = Form;
Form.defaultProps = {
  autoComplete: 'off',
  name: '',
  id: ''
};

Form.Field = function (props) {
  var children = props.children,
      label = props.label,
      id = props.id,
      size = props.size,
      required = props.required;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Typography.Text, (0, _extends2.default)({
    as: "label",
    htmlFor: id,
    size: (0, _functions.getSizeTextInput)(size),
    width: "100%",
    color: !label ? 'transparent' : 'inherit',
    marginY: 3,
    display: "block"
  }, props), label || '.', required && _react.default.createElement(_Typography.Text, {
    as: "span",
    color: "rambutan",
    size: (0, _functions.getSizeTextInput)(size)
  }, ' ', "*")), children);
};

Form.Field.propTypes = {
  children: _propTypes2.default.node,
  label: _propTypes2.default.string,
  id: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['tiny', 'small', 'medium', 'large', 'huge']),
  required: _propTypes2.default.bool
};
Form.Field.defaultProps = {
  label: null,
  id: null,
  size: 'medium',
  children: null,
  required: false
};

Form.Input = function (props) {
  var borderless = props.borderless,
      type = props.type,
      hasError = props.hasError,
      isLoading = props.isLoading,
      size = props.size,
      placeholderMessage = props.placeholderMessage,
      iconRight = props.iconRight,
      iconLeft = props.iconLeft,
      onClick = props.onClick,
      disabled = props.disabled,
      display = props.display;
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Box, {
    position: "relative"
  }, borderless ? _react.default.createElement(_styles.InputBorderlesStyled, (0, _extends2.default)({
    borderRadius: 1,
    type: type,
    hasError: hasError,
    size: "small",
    placeholder: placeholderMessage
  }, props)) : _react.default.createElement(_react.default.Fragment, null, iconLeft && !isLoading && _react.default.createElement(_styles.InputIconBoxStyled, {
    height: "100%",
    position: "absolute",
    display: "flex",
    alignItems: "center",
    top: "0",
    left: "0",
    zIndex: 0,
    onClick: onClick,
    hasError: hasError,
    style: {
      cursor: disabled && 'not-allowed',
      boxShadow: disabled && 'none'
    }
  }, _react.default.createElement(_styles.InputIconLeftStyled, {
    size: "none",
    space: size,
    position: "absolute",
    color: "guama"
  }, iconLeft)), _react.default.createElement(_styles.InputStyled, (0, _extends2.default)({
    borderRadius: 1,
    type: type,
    hasError: hasError,
    size: size,
    placeholder: placeholderMessage
  }, props)), iconRight && !isLoading && _react.default.createElement(_styles.InputIconBoxStyled, {
    width: "100%",
    height: "100%",
    position: "absolute",
    display: display || 'flex',
    alignItems: "center",
    top: "0",
    left: "0",
    zIndex: 0,
    onClick: onClick,
    hasError: hasError,
    style: {
      cursor: disabled && 'not-allowed',
      boxShadow: disabled && 'none'
    }
  }, _react.default.createElement(_styles.InputIconRightStyled, {
    size: "none",
    space: size,
    position: "absolute",
    color: "guama"
  }, iconRight)), isLoading && _react.default.createElement(_styles.InputIconBoxStyled, {
    background: "linear-gradient(90deg, rgba(255,255,255,0) 50%, rgb(255, 255, 255) 85%, rgb(255, 255, 255) 100%)",
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0",
    left: "0",
    display: "flex",
    alignItems: "center"
  }, _react.default.createElement(_styles.InputIconRightStyled, {
    size: "none",
    space: size,
    position: "absolute",
    color: "guama"
  }, _react.default.createElement(_Loader.Loader, null))))));
};

Form.Input.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _propTypes.default.space), {}, {
  id: _propTypes2.default.string,
  title: _propTypes2.default.string,
  name: _propTypes2.default.string,
  autoComplete: _propTypes2.default.oneOf(['on', 'off']),
  tabIndex: _propTypes2.default.number,
  type: _propTypes2.default.oneOf(['text', 'password', 'submit', 'reset', 'hidden', 'datetime-local', 'date', 'month', 'time', 'week', 'number', 'range', 'email', 'url', 'search', 'tel', 'color']),
  ariaHelpId: _propTypes2.default.string,
  ariaHelpMessage: _propTypes2.default.string,
  placeholderMessage: _propTypes2.default.string,
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  disabled: _propTypes2.default.bool,
  maxLength: _propTypes2.default.number,
  readOnly: _propTypes2.default.bool,
  pattern: _propTypes2.default.string,
  required: _propTypes2.default.bool,
  min: _propTypes2.default.string,
  max: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  hasError: _propTypes2.default.bool,
  borderless: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['tiny', 'small', 'medium', 'large', 'huge', 'gigantic'])
}, _propTypes.default.border), _propTypes.default.space), _propTypes.default.flexbox), _propTypes.default.layout), _propTypes.default.color);
Form.Input.defaultProps = {
  id: '',
  title: '',
  tabIndex: 0,
  type: 'text',
  ariaHelpId: null,
  ariaHelpMessage: null,
  placeholderMessage: null,
  defaultValue: null,
  name: '',
  disabled: false,
  maxLength: null,
  readOnly: false,
  size: 75,
  autoComplete: 'on',
  pattern: null,
  required: false,
  min: null,
  max: null,
  onChange: null,
  onBlur: null,
  hasError: false,
  borderless: false
};

Form.Error = function (props) {
  var children = props.children;
  return _react.default.createElement(_Typography.Text, (0, _extends2.default)({
    size: "micro",
    as: "span",
    display: "block",
    color: "rambutan",
    marginTop: 2
  }, props), children);
};

Form.Error.propTypes = _objectSpread({
  children: _propTypes2.default.node.isRequired
}, _propTypes.default.layout);

var BlockStyleControls = function BlockStyleControls(props) {
  var editorState = props.editorState;
  var selection = editorState.getSelection();
  var blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  var BLOCK_TYPES = [{
    label: _react.default.createElement(_Icons.Heading, null),
    style: 'header-four',
    title: 'Header'
  }, {
    label: _react.default.createElement(_Icons.ListUl, null),
    style: 'unordered-list-item',
    title: 'List'
  }, {
    label: _react.default.createElement(_Icons.QuoteSolid, null),
    style: 'blockquote',
    title: 'Blockquote'
  }];
  return BLOCK_TYPES.map(function (type) {
    return _react.default.createElement(StyleButton, {
      key: type.title,
      active: type.style === blockType,
      label: type.label,
      onToggle: props.onToggle,
      style: type.style,
      title: type.title
    });
  });
};

var StyleButton = function StyleButton(props) {
  var active = props.active,
      onToggle = props.onToggle,
      style = props.style,
      label = props.label,
      title = props.title;

  var onToggleButton = function onToggleButton(e) {
    e.preventDefault();
    onToggle(style);
  };

  return _react.default.createElement(_styles.BBCodeButtonIconStyled, {
    size: "micro",
    color: active ? 'rambutan' : 'guijarro',
    onMouseDown: onToggleButton,
    marginRight: 5,
    title: title
  }, label);
};

StyleButton.defaultProps = {
  active: false,
  onToggle: function onToggle() {},
  style: '',
  label: '',
  title: ''
};

var InlineStyleControls = function InlineStyleControls(props) {
  var editorState = props.editorState;
  var currentStyle = editorState.getCurrentInlineStyle();
  var INLINE_STYLES = [{
    label: _react.default.createElement(_Icons.Bold, null),
    style: 'BOLD',
    title: 'Bold'
  }, {
    label: _react.default.createElement(_Icons.Italic, null),
    style: 'ITALIC',
    title: 'Italic'
  }];
  return INLINE_STYLES.map(function (type) {
    return _react.default.createElement(StyleButton, {
      key: type.title,
      active: currentStyle.has(type.style),
      label: type.label,
      onToggle: props.onToggle,
      style: type.style,
      title: type.title
    });
  });
};

Form.SimpleBBCodeTextarea = function (_ref) {
  var id = _ref.id,
      name = _ref.name,
      defaultValue = _ref.defaultValue,
      onChange = _ref.onChange,
      hasError = _ref.hasError,
      promptUrlMessage = _ref.promptUrlMessage,
      placeholderMessage = _ref.placeholderMessage,
      errorMessage = _ref.errorMessage,
      autoFocus = _ref.autoFocus,
      showsCounter = _ref.showsCounter,
      maxLength = _ref.maxLength,
      minLength = _ref.minLength,
      backgroundColor = _ref.backgroundColor;
  var textareaRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(defaultValue.length),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      textLength = _useState2[0],
      setTextLength = _useState2[1];

  var _useState3 = (0, _react.useState)(maxLength),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      textMaxLength = _useState4[0],
      setTextMaxLength = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      respectsLength = _useState6[0],
      setRespectsLength = _useState6[1];

  (0, _react.useEffect)(function () {
    if (showsCounter && defaultValue !== null && defaultValue !== void 0 && defaultValue.length) {
      var initialTextLength = defaultValue.length || 0;
      setRespectsLength(initialTextLength >= minLength && initialTextLength < maxLength);
    }
  }, [defaultValue]);

  var handleOnChange = function handleOnChange(event) {
    if (showsCounter) {
      var originalText = event.target.value;
      var text = (0, _textUtils.removeTextTags)(originalText);
      var length = text.length;
      var discardedLength = originalText.length - length;
      setRespectsLength(length >= minLength && length < maxLength);
      setTextMaxLength(maxLength + discardedLength);
      setTextLength(length);
    }

    onChange(event);
  };

  var addTag = function addTag(tag) {
    var textarea = textareaRef.current;
    var originalContent = textarea.value;
    var caretPosition = (0, _functions.getCaret)(textarea);
    var selectedContent = '';
    var selectionStart = null;
    var selectionEnd = null;
    var contentWithTags;
    var previousContent = '';
    var laterContent = '';

    if (document.selection) {
      selectionStart = 0;
      selectionEnd = originalContent.length;
      selectedContent = document.selection.createRange().text;
    } else {
      selectionStart = textarea.selectionStart;
      selectionEnd = textarea.selectionEnd;
      selectedContent = originalContent.slice(selectionStart, selectionEnd);
    }

    switch (tag) {
      case 'list':
        contentWithTags = "[".concat(tag, "][*]").concat(selectedContent, "[/").concat(tag, "]");
        break;

      case 'url':
        var url = prompt(promptUrlMessage);
        contentWithTags = "[".concat(tag, "=").concat(url, "]").concat(selectedContent, "[/").concat(tag, "]");
        break;

      default:
        contentWithTags = "[".concat(tag, "]").concat(selectedContent, "[/").concat(tag, "]");
    }

    if (selectedContent === '') {
      previousContent = originalContent.slice(0, caretPosition);
      laterContent = originalContent.slice(caretPosition, originalContent.length);
      caretPosition = parseInt(previousContent.length + contentWithTags.length - tag.length - 3);
      textarea.value = previousContent + contentWithTags + laterContent;
    } else {
      previousContent = originalContent.slice(0, selectionStart);
      laterContent = originalContent.slice(selectionEnd, originalContent.length);
      caretPosition = parseInt(previousContent.length + contentWithTags.length);

      if (document.selection) {
        document.selection.createRange().text = previousContent + contentWithTags + laterContent;
      } else {
        textarea.value = previousContent + contentWithTags + laterContent;
      }
    }

    (0, _functions.setCaret)(textarea, caretPosition);
    onChange({
      target: {
        value: textarea.value
      }
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.BBCodeTextareaStyled, {
    backgroundColor: backgroundColor,
    padding: 6,
    borderRadius: 1,
    key: id,
    hasError: hasError,
    name: name
  }, _react.default.createElement(_styles.BBCodeControlsStyled, null, _react.default.createElement(StyleButton, {
    key: "Bold",
    label: _react.default.createElement(_Icons.Bold, null),
    onToggle: function onToggle() {
      return addTag('b');
    },
    style: "BOLD",
    title: "Bold"
  }), _react.default.createElement(StyleButton, {
    key: "Italic",
    label: _react.default.createElement(_Icons.Italic, null),
    onToggle: function onToggle() {
      return addTag('i');
    },
    style: "ITALIC",
    title: "Italic"
  }), _react.default.createElement(StyleButton, {
    key: "URL",
    label: _react.default.createElement(_Icons.LinkIcon, null),
    onToggle: function onToggle() {
      return addTag('url');
    },
    style: "a",
    title: "URL"
  }), _react.default.createElement(StyleButton, {
    key: "Header",
    label: _react.default.createElement(_Icons.Heading, null),
    onToggle: function onToggle() {
      return addTag('h');
    },
    style: "header-four",
    title: "Header"
  }), _react.default.createElement(StyleButton, {
    key: "List",
    label: _react.default.createElement(_Icons.ListUl, null),
    onToggle: function onToggle() {
      return addTag('list');
    },
    style: "unordered-list-item",
    title: "List"
  }), _react.default.createElement(StyleButton, {
    key: "Blockquote",
    label: _react.default.createElement(_Icons.QuoteSolid, null),
    onToggle: function onToggle() {
      return addTag('quote');
    },
    style: "blockquote",
    title: "Blockquote"
  })), _react.default.createElement(_styles.BBCodeEditorStyled, {
    fontSize: 4,
    marginTop: 6,
    minHeight: "116px"
  }, _react.default.createElement(Form.Textarea, {
    placeholderMessage: placeholderMessage,
    defaultValue: defaultValue,
    forwardRef: textareaRef,
    onChange: handleOnChange,
    style: {
      boxShadow: 'none',
      backgroundColor: 'transparent',
      padding: 0
    },
    autoFocus: autoFocus,
    maxLength: textMaxLength
  }))), _react.default.createElement(_Layout.Grid, {
    gridRowGap: 0,
    style: {
      justifyContent: 'space-between'
    }
  }, _react.default.createElement(_Layout.GridItem, {
    gridRow: "1",
    gridColumn: "1"
  }, hasError && _react.default.createElement(Form.Error, null, errorMessage)), _react.default.createElement(_Layout.GridItem, {
    gridRow: "1",
    gridColumn: "8"
  }, showsCounter && maxLength && _react.default.createElement(_Typography.Text, (0, _extends2.default)({
    size: "micro",
    as: "span",
    display: "block",
    color: "guijarro",
    marginTop: 2
  }, !respectsLength ? {
    color: 'rambutan'
  } : {}), textLength, "/", maxLength))));
};

Form.SimpleBBCodeTextarea.propTypes = {
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  defaultValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  hasError: _propTypes2.default.bool,
  promptUrlMessage: _propTypes2.default.string,
  placeholderMessage: _propTypes2.default.string,
  errorMessage: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  showsCounter: _propTypes2.default.bool,
  minLength: _propTypes2.default.number,
  maxLength: _propTypes2.default.number,
  backgroundColor: _propTypes2.default.string
};
Form.SimpleBBCodeTextarea.defaultProps = {
  id: '',
  name: '',
  defaultValue: null,
  onChange: function onChange() {},
  hasError: false,
  promptUrlMessage: 'Añadir enlace',
  placeholderMessage: 'Escribe aquí tu texto...',
  errorMessage: '',
  autoFocus: false,
  showsCounter: false,
  minLength: 0,
  maxLength: null,
  backgroundColor: 'ghosted.copoazu.light'
};

Form.BBCodeTextarea = function (_ref2) {
  var placeholderMessage = _ref2.placeholderMessage,
      action = _ref2.action,
      defaultValue = _ref2.defaultValue,
      readOnly = _ref2.readOnly,
      id = _ref2.id,
      name = _ref2.name,
      _onBlur = _ref2.onBlur,
      hasError = _ref2.hasError,
      errorMessage = _ref2.errorMessage;

  var createState = function createState(value) {
    var blocksFromHTML = (0, _draftJs.convertFromHTML)(value);

    var raw = _draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

    return raw;
  };

  var calculateState = function calculateState(value) {
    return value ? _draftJs.EditorState.createWithContent(createState(value)) : _draftJs.EditorState.createEmpty(_addLinkPlugin.default.decorators);
  };

  var _useState7 = (0, _react.useState)(calculateState(defaultValue)),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      editorState = _useState8[0],
      setEditorState = _useState8[1];

  (0, _react.useEffect)(function () {
    var state = calculateState(defaultValue);
    setEditorState(state);
  }, [defaultValue]);

  var _React$useState = _react.default.useState(''),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      urlValue = _React$useState2[0],
      setUrlValue = _React$useState2[1];

  var _React$useState3 = _react.default.useState(false),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      showUrlInput = _React$useState4[0],
      setShowUrlInput = _React$useState4[1];

  var editor = (0, _react.useRef)();

  var handleKeyCommand = function handleKeyCommand(command) {
    var newState = _draftJs.RichUtils.handleKeyCommand(editorState, command);

    if (newState) {
      setEditorState(newState);
      return true;
    }

    return false;
  };

  var onTab = function onTab(e) {
    var maxDepth = 4;

    var onTabAction = _draftJs.RichUtils.DraftEditor(e, editorState, maxDepth);

    setEditorState(onTabAction);
  };

  var focusEditor = function focusEditor() {
    editor.current.focus();
  };

  var toggleBlockType = function toggleBlockType(blockType) {
    setEditorState(_draftJs.RichUtils.toggleBlockType(editorState, blockType));
  };

  var toggleInlineStyle = function toggleInlineStyle(inlineStyle) {
    setEditorState(_draftJs.RichUtils.toggleInlineStyle(editorState, inlineStyle));
  };

  var promptForLink = function promptForLink(e) {
    e.preventDefault();
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      var contentState = editorState.getCurrentContent();
      var startKey = editorState.getSelection().getStartKey();
      var startOffset = editorState.getSelection().getStartOffset();
      var blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
      var linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
      var url = '';

      if (linkKey) {
        var linkInstance = contentState.getEntity(linkKey);
        url = linkInstance.getData().url;
      }

      setUrlValue(url);
      setShowUrlInput(true);
    } else {
      alert('selecciona el texto a enlazar');
    }
  };

  var confirmLink = function confirmLink(e) {
    e.preventDefault();
    var contentState = editorState.getCurrentContent();
    var contentStateWithEntity = urlValue ? contentState.createEntity('LINK', 'MUTABLE', {
      url: urlValue
    }) : contentState.createEntity('', 'MUTABLE', {
      url: urlValue
    });
    var entityKey = contentStateWithEntity.getLastCreatedEntityKey();

    var newEditorState = _draftJs.EditorState.set(editorState, {
      currentContent: contentStateWithEntity
    });

    setEditorState(_draftJs.RichUtils.toggleLink(newEditorState, newEditorState.getSelection(), entityKey));
    setUrlValue('');
    setShowUrlInput(false);
  };

  var onLinkInputKeyDown = function onLinkInputKeyDown(e) {
    if (e.which === 13) {
      confirmLink(e);
    }
  };

  var removeLink = function removeLink(e) {
    e.preventDefault();
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      setEditorState(_draftJs.RichUtils.toggleLink(editorState, selection, null));
    }
  };

  (0, _react.useEffect)(function () {
    focusEditor();
  }, []);

  var getBlockStyle = function getBlockStyle(block) {
    switch (block.getType()) {
      case 'blockquote':
        return 'RichEditor-blockquote';

      default:
        return null;
    }
  };

  var onChangeEditor = function onChangeEditor(e) {
    setEditorState(e);
    var rawContentState = (0, _draftJs.convertToRaw)(e.getCurrentContent());
    var markup = (0, _draftjsToBbcode.default)(rawContentState, {
      trigger: '#',
      separator: ' '
    }, true, {
      trigger: '\b',
      separator: '[\br]'
    });
    if (action) action({
      raw: rawContentState,
      bbcode: markup
    });
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.BBCodeTextareaStyled, {
    backgroundColor: "ghosted.copoazu.light",
    padding: 6,
    borderRadius: 1,
    key: id,
    hasError: hasError,
    name: name
  }, _react.default.createElement(_Modal.Modal, {
    width: "auto",
    heigth: "auto",
    isOpen: showUrlInput,
    id: "dmstk-modal-link",
    onModalClose: function onModalClose() {
      return setShowUrlInput(false);
    }
  }, _react.default.createElement(_Modal.Modal.Title, null, "A\xF1adir enlace"), _react.default.createElement(_Modal.Modal.Content, null, _react.default.createElement(Form.Input, {
    onChange: function onChange(e) {
      return setUrlValue(e.target.value);
    },
    type: "text",
    size: "large",
    value: urlValue,
    onKeyDown: function onKeyDown(e) {
      return onLinkInputKeyDown(e);
    },
    width: ['auto', 'auto', '400px']
  })), _react.default.createElement(_Modal.Modal.Actions, null, _react.default.createElement(_Layout.Grid, {
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr",
    gridColumnGap: 3,
    marginTop: 5
  }, _react.default.createElement(_Buttons.Button, {
    size: "medium",
    hollow: "secondary",
    buttonType: "secondary",
    onMouseDown: function onMouseDown() {
      return setShowUrlInput(false);
    }
  }, _react.default.createElement(_Typography.TextForm, {
    size: ['tiny', 'tiny', 'small'],
    fontWeight: "medium",
    color: "sonar"
  }, "Cancelar")), _react.default.createElement(_Buttons.Button, {
    onMouseDown: function onMouseDown(e) {
      return confirmLink(e);
    }
  }, _react.default.createElement(_Typography.TextForm, {
    size: ['tiny', 'tiny', 'small'],
    fontWeight: "medium",
    color: "coco"
  }, "Guardar"))))), _react.default.createElement(_styles.BBCodeControlsStyled, null, _react.default.createElement(InlineStyleControls, {
    editorState: editorState,
    onToggle: toggleInlineStyle
  }), _react.default.createElement(_Buttons.Button, {
    action: function action(e) {
      promptForLink(e);
    },
    marginRight: 5,
    size: "none",
    buttonType: "text",
    display: "inline-block",
    disabled: !!editorState.getSelection().isCollapsed(),
    title: "Link"
  }, _react.default.createElement(_Icon.Icon, {
    size: "micro",
    color: "guijarro"
  }, _react.default.createElement(_Icons.LinkIcon, null))), _react.default.createElement(BlockStyleControls, {
    editorState: editorState,
    onToggle: toggleBlockType
  })), _react.default.createElement(_styles.BBCodeEditorStyled, {
    fontSize: 4,
    marginTop: 6,
    minHeight: "116px",
    onClick: function onClick() {
      return focusEditor();
    }
  }, _react.default.createElement(_draftJs.Editor, {
    blockStyleFn: getBlockStyle,
    editorState: editorState,
    handleKeyCommand: handleKeyCommand,
    onChange: function onChange(e) {
      return onChangeEditor(e);
    },
    onTab: onTab,
    ref: editor,
    onBlur: function onBlur() {
      return _onBlur && _onBlur();
    },
    placeholder: placeholderMessage || 'Escribe aquí tu texto',
    spellCheck: true,
    readOnly: readOnly
  }))), hasError && _react.default.createElement(Form.Error, null, errorMessage));
};

Form.BBCodeTextarea.propTypes = {
  placeholderMessage: _propTypes2.default.string,
  action: _propTypes2.default.func.isRequired,
  defaultValue: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  hasError: _propTypes2.default.bool,
  errorMessage: _propTypes2.default.string
};
Form.BBCodeTextarea.defaultProps = {
  placeholderMessage: null,
  defaultValue: null,
  readOnly: false,
  id: '',
  name: '',
  onBlur: function onBlur() {},
  hasError: false,
  errorMessage: ''
};

Form.Textarea = function (props) {
  var placeholderMessage = props.placeholderMessage,
      forwardRef = props.forwardRef;

  var autoGrow = function autoGrow() {
    var textarea = forwardRef.current;
    if (!textarea) return;
    textarea.style.height = '1px';
    textarea.style.height = "".concat(textarea.scrollHeight, "px");
  };

  return _react.default.createElement(_styles.TextareaStyled, (0, _extends2.default)({
    fontSize: [4, 3, 4],
    lineHeight: [5, 5, 5],
    paddingY: [4, 4, 4],
    paddingX: [4, 4, 4],
    borderRadius: 1,
    placeholder: placeholderMessage,
    ref: forwardRef,
    onKeyUp: autoGrow,
    onFocus: autoGrow,
    overflow: "hidden"
  }, props));
};

Form.Textarea.propTypes = {
  placeholderMessage: _propTypes2.default.string,
  forwardRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    current: _propTypes2.default.instanceOf(Element)
  })])
};
Form.Textarea.defaultProps = {
  placeholderMessage: null,
  forwardRef: function forwardRef() {}
};

Form.Select = function (props) {
  var name = props.name,
      size = props.size,
      placeholderMessage = props.placeholderMessage,
      options = props.options,
      selected = props.selected,
      onSelected = props.onSelected;
  var emptyOption = {
    value: '',
    label: placeholderMessage
  };

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      isOpened = _useState10[0],
      setIsOpened = _useState10[1];

  var _useState11 = (0, _react.useState)(options.find(function (option) {
    return option.value === String(selected);
  })),
      _useState12 = (0, _slicedToArray2.default)(_useState11, 2),
      valueSelected = _useState12[0],
      setValueSelected = _useState12[1];

  var wrapperRef = (0, _react.useRef)(null);
  var inputRef = (0, _react.useRef)(null);

  var handleEsc = function handleEsc(e) {
    if (e.keyCode === 27) {
      setIsOpened(false);
    }
  };

  var handleToggle = (0, _react.useCallback)(function (e) {
    var _wrapperRef$current, _inputRef$current;

    if (!((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(e.target)) && !((_inputRef$current = inputRef.current) !== null && _inputRef$current !== void 0 && _inputRef$current.contains(e.target))) {
      setIsOpened(false);
    }
  }, [wrapperRef.current]);
  (0, _react.useEffect)(function () {
    document.addEventListener('click', handleToggle);
    document.addEventListener('keyup', handleEsc);
    return function () {
      document.removeEventListener('click', handleToggle);
      document.removeEventListener('keyup', handleEsc);
    };
  }, []);
  return _react.default.createElement(_Layout.Box, {
    ref: wrapperRef
  }, _react.default.createElement("select", {
    name: name,
    style: {
      display: 'none'
    },
    defaultValue: valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.value,
    value: valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.value
  }, _react.default.createElement("option", null, placeholderMessage), options.map(function (option) {
    return _react.default.createElement("option", {
      key: option.value,
      "aria-selected": option.value === (valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.value),
      value: option.value,
      id: "selectItem-".concat(option.value)
    }, option.label);
  })), _react.default.createElement(Form.Input, (0, _extends2.default)({
    display: isOpened && 'none',
    readOnly: true,
    ref: inputRef,
    type: "text",
    size: size,
    onClick: function onClick() {
      if (!props.disabled) {
        setIsOpened(true);
      }
    },
    placeholderMessage: placeholderMessage,
    defaultValue: valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.label,
    value: valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.label,
    iconRight: _react.default.createElement(_Icons.ChevronDown, null)
  }, props)), _react.default.createElement(_styles.SelectStyled, (0, _extends2.default)({
    key: "select-".concat(name),
    as: "div",
    maxHeight: (0, _functions.setMaxHeightSelectBox)(size),
    overflow: "auto",
    display: !isOpened ? 'none' : 'inherit',
    size: size
  }, props, {
    ariaLabelledby: "selectItems"
  }), _react.default.createElement(_styles.SelectOptionsListStyled, {
    key: "placeholderSelect",
    display: "flex",
    alignItems: "center",
    color: "guijarro",
    justifyContent: "space-between",
    paddingBottom: 2,
    onClick: function onClick() {
      setValueSelected(emptyOption);
      setIsOpened(false);
      if (onSelected) onSelected(emptyOption);
    },
    size: size
  }, placeholderMessage, _react.default.createElement(_Icon.IconForm, {
    size: "none"
  }, _react.default.createElement(_Icons.ChevronUp, null))), options.map(function (option) {
    return _react.default.createElement(_styles.SelectOptionsListStyled, {
      key: option.value,
      paddingBottom: 2,
      color: option.value === (valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.value) ? 'sonar' : 'guijarro',
      "data-name": option.value,
      role: "option",
      size: size,
      id: "selectOption_".concat(option.value),
      onClick: function onClick() {
        setValueSelected(option);
        setIsOpened(false);
        if (onSelected) onSelected(option);
      },
      ariaSelected: option.value === (valueSelected === null || valueSelected === void 0 ? void 0 : valueSelected.value)
    }, option.label);
  })));
};

Form.Select.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
  id: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  hasError: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['tiny', 'small', 'medium', 'large', 'huge', 'gigantic']),
  ariaHelpId: _propTypes2.default.string,
  ariaHelpMessage: _propTypes2.default.string,
  placeholderMessage: _propTypes2.default.string,
  defaultValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    value: _propTypes2.default.string,
    label: _propTypes2.default.string
  })).isRequired,
  selected: _propTypes2.default.string,
  onSelected: _propTypes2.default.func
}, _propTypes.default.border), _propTypes.default.space), _propTypes.default.flexbox), _propTypes.default.layout), _propTypes.default.color), _propTypes.default.space);
Form.Select.defaultProps = {
  id: 'select-X',
  hasError: false,
  isLoading: false,
  size: 'small',
  ariaHelpId: '',
  ariaHelpMessage: '',
  defaultValue: null,
  placeholderMessage: 'Elige una opción',
  onSelected: function onSelected() {},
  selected: ''
};

Form.ContentVideo = function (_ref3) {
  var label = _ref3.label,
      isLoaded = _ref3.isLoaded,
      isLoading = _ref3.isLoading,
      data = _ref3.data,
      defaultValue = _ref3.defaultValue,
      noteMessage = _ref3.noteMessage,
      errorMessage = _ref3.errorMessage,
      rest = (0, _objectWithoutProperties2.default)(_ref3, ["label", "isLoaded", "isLoading", "data", "defaultValue", "noteMessage", "errorMessage"]);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Box, {
    backgroundColor: "ghosted.copoazu.light",
    padding: 6,
    borderRadius: 2,
    position: "relative"
  }, _react.default.createElement(Form.Field, {
    size: "tiny",
    label: label || 'Añade aquí la URL de un vídeo o audio',
    marginBottom: 3,
    marginY: 0
  }, _react.default.createElement(Form.Input, (0, _extends2.default)({
    size: "medium",
    placeholderMessage: "https://",
    isLoading: isLoading,
    defaultValue: defaultValue
  }, rest)), _react.default.createElement(Form.Error, null, errorMessage), _react.default.createElement(_Typography.Text, {
    size: "micro",
    color: "guijarro",
    marginTop: 3
  }, _react.default.createElement(_Icon.Icon, {
    size: "micro",
    display: "inline-block",
    marginRight: 1,
    color: "guijarro"
  }, _react.default.createElement(_Icons.InfoCircle, null)), noteMessage))), isLoaded && _react.default.createElement(_Layout.Box, {
    backgroundColor: "transparent",
    marginTop: 4
  }, _react.default.createElement(_styles.ContentVideoEmbebedStyled, {
    dangerouslySetInnerHTML: {
      __html: data === null || data === void 0 ? void 0 : data.embedHtml
    }
  }), _react.default.createElement(_Layout.Flex, {
    justifyContent: "space-between"
  }, _react.default.createElement(_Layout.Box, null, _react.default.createElement(_Typography.Text, {
    style: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    size: "small",
    fontWeight: "medium",
    marginTop: 4,
    maxWidth: "200px"
  }, data === null || data === void 0 ? void 0 : data.embedTitle), _react.default.createElement(_Typography.Text, {
    marginTop: [0, 0, 1],
    size: "tiny",
    color: "guijarro",
    style: {
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    maxWidth: "225px"
  }, data === null || data === void 0 ? void 0 : data.embedDescription)), _react.default.createElement(_Layout.Box, null, _react.default.createElement(_Typography.Text, {
    size: "tiny",
    color: "guijarro",
    marginTop: 4
  }, data === null || data === void 0 ? void 0 : data.embedProviderName)))));
};

Form.ContentVideo.propTypes = {
  label: _propTypes2.default.string,
  isLoaded: _propTypes2.default.bool,
  isLoading: _propTypes2.default.bool,
  defaultValue: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    embedHtml: _propTypes2.default.string,
    embedTitle: _propTypes2.default.string,
    embedDescription: _propTypes2.default.string,
    embedProviderName: _propTypes2.default.string,
    embedAuthorName: _propTypes2.default.string,
    embedType: _propTypes2.default.string
  }),
  noteMessage: _propTypes2.default.string
};
Form.ContentVideo.defaultProps = {
  label: null,
  isLoaded: false,
  isLoading: false,
  defaultValue: null,
  data: {
    embedHtml: null,
    embedTitle: null,
    embedDescription: null,
    embedProviderName: null,
    embedAuthorName: null,
    embedType: null
  },
  noteMessage: 'Servicios disponibles: Vimeo, YouTube, SoundCloud, Facebook videos, Instagram, Flickr, Spotify, Dailymotion, Giphy, Sketchfab, Wistia'
};

var noop = function noop() {};

var MAX_FILE_SIZE_MG = 10;
var ALLOWED_IMG_TYPES = ['image/jpeg', 'image/gif', 'image/png', 'image/pjpeg', 'image/x-png'];

Form.Uploader = function (_ref4) {
  var maxUploadSizeMessage = _ref4.maxUploadSizeMessage,
      maxNumFiles = _ref4.maxNumFiles,
      minWidth = _ref4.minWidth,
      minHeight = _ref4.minHeight,
      descriptionMessage = _ref4.descriptionMessage,
      progressMessage = _ref4.progressMessage,
      hasError = _ref4.hasError,
      progressNumber = _ref4.progressNumber,
      multiple = _ref4.multiple,
      size = _ref4.size,
      onImagesLoad = _ref4.onImagesLoad,
      _ref4$onChange = _ref4.onChange,
      _onChange = _ref4$onChange === void 0 ? noop : _ref4$onChange,
      loading = _ref4.loading,
      errors = _ref4.errors,
      name = _ref4.name,
      required = _ref4.required;

  var dropRef = _react.default.useRef();

  var inputRef = _react.default.useRef();

  var canvasRef = _react.default.useRef();

  var _React$useState5 = _react.default.useState(false),
      _React$useState6 = (0, _slicedToArray2.default)(_React$useState5, 2),
      draggin = _React$useState6[0],
      setDraggin = _React$useState6[1];

  var _React$useState7 = _react.default.useState(loading),
      _React$useState8 = (0, _slicedToArray2.default)(_React$useState7, 2),
      isLoading = _React$useState8[0],
      setLoading = _React$useState8[1];

  var _React$useState9 = _react.default.useState(0),
      _React$useState10 = (0, _slicedToArray2.default)(_React$useState9, 2),
      dragCounter = _React$useState10[0],
      setDragCounter = _React$useState10[1];

  var _React$useState11 = _react.default.useState(descriptionMessage),
      _React$useState12 = (0, _slicedToArray2.default)(_React$useState11, 2),
      messageToShow = _React$useState12[0],
      setMessageToShow = _React$useState12[1];

  var _React$useState13 = _react.default.useState([]),
      _React$useState14 = (0, _slicedToArray2.default)(_React$useState13, 2),
      errorToShow = _React$useState14[0],
      setErrorToShow = _React$useState14[1];

  var _React$useState15 = _react.default.useState(false),
      _React$useState16 = (0, _slicedToArray2.default)(_React$useState15, 2),
      errorStatus = _React$useState16[0],
      setErrorStatus = _React$useState16[1];

  var _React$useState17 = _react.default.useState([]),
      _React$useState18 = (0, _slicedToArray2.default)(_React$useState17, 2),
      erroredImages = _React$useState18[0],
      setErroredImages = _React$useState18[1];

  var resetErrorStatus = function resetErrorStatus() {
    setErrorStatus(false);
    setErrorToShow([]);
    setErroredImages([]);
  };

  var addError = function addError(imageName, typeOfError) {
    if (!erroredImages.find(function (eImage) {
      return eImage.name === imageName;
    })) {
      var errorImages = erroredImages;
      errorImages.push({
        type: typeOfError,
        name: imageName
      });
      setErroredImages(errorImages);
    }
  };

  var readAsDataURL = function readAsDataURL(element) {
    return new Promise(function (resolve, reject) {
      var fileName = element.name;

      if (!ALLOWED_IMG_TYPES.includes(element.type)) {
        addError(fileName, 'wrongType');
        resolve({
          error: 'wrongType',
          image: fileName
        });
      }

      var imgSize = element.size / 1000000;

      if (imgSize > MAX_FILE_SIZE_MG) {
        addError(fileName, 'size');
        resolve({
          error: 'size',
          image: fileName
        });
      }

      var reader = new FileReader();

      reader.onprogress = function () {
        setLoading(true);
      };

      reader.onerror = reject;

      reader.onload = function (event) {
        setLoading(true);
        var img = new Image();
        img.src = event.target.result;

        img.onload = function () {
          if (img.width < minWidth && img.height < minHeight) {
            addError(fileName, 'dimensions.width_and_height');
            resolve({
              error: 'dimensions.width_and_height',
              image: fileName
            });
          } else if (img.width < minWidth) {
            addError(fileName, 'dimensions.width');
            resolve({
              error: 'dimensions.width',
              image: fileName
            });
          } else if (img.height < minHeight) {
            addError(fileName, 'dimensions.height');
            resolve({
              error: 'dimensions.height',
              image: fileName
            });
          } else {
            resolve({
              name: fileName,
              base64: event.target.result
            });
          }

          handleImages(element);

          if (canvasRef !== null && canvasRef !== void 0 && canvasRef.current) {
            canvasRef.current.width = img.width || '100%';
            canvasRef.current.height = img.height;
            canvasRef.current.getContext('2d').drawImage(img, 0, 0);
          }
        };
      };

      reader.onloadend = function () {
        setLoading(loading);
      };

      reader.readAsDataURL(element);
    });
  };

  var createErrorMessages = function createErrorMessages() {
    var wrongTypeImages = [];
    var wrongSizeImages = [];
    var wrongDimensionsImages = [];
    var wrongWidthImages = [];
    var wrongHeightImages = [];
    var errorMessages = [];
    erroredImages.forEach(function (image) {
      if (image.type === 'dimensions.width_and_height') {
        wrongDimensionsImages.push(image.name);
      }

      if (image.type === 'dimensions.width') {
        wrongWidthImages.push(image.name);
      }

      if (image.type === 'dimensions.height') {
        wrongHeightImages.push(image.name);
      }

      if (image.type === 'size') {
        wrongSizeImages.push(image.name);
      }

      if (image.type === 'wrongType') {
        wrongTypeImages.push(image.name);
      }
    });

    if (wrongSizeImages.length > 0) {
      var error = errors.find(function (e) {
        return e.type === 'size';
      });
      errorMessages.push(error.message(wrongSizeImages));
    }

    if (wrongTypeImages.length > 0) {
      var _error = errors.find(function (e) {
        return e.type === 'wrongType';
      });

      errorMessages.push(_error.message(wrongTypeImages));
    }

    if (wrongDimensionsImages.length > 0) {
      var _error2 = errors.find(function (e) {
        return e.type === 'dimensions.width_and_height';
      });

      errorMessages.push(_error2.message(wrongDimensionsImages, minWidth, minHeight));
    }

    if (wrongWidthImages.length > 0) {
      var _error3 = errors.find(function (e) {
        return e.type === 'dimensions.width';
      });

      errorMessages.push(_error3.message(wrongWidthImages, minWidth));
    }

    if (wrongHeightImages.length > 0) {
      var _error4 = errors.find(function (e) {
        return e.type === 'dimensions.height';
      });

      errorMessages.push(_error4.message(wrongHeightImages, minHeight));
    }

    return errorMessages;
  };

  var handleImages = function () {
    var _ref5 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(files) {
      var error, errorMessages;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setErroredImages([]);
              _context.prev = 1;

              if (!(files.length > maxNumFiles)) {
                _context.next = 7;
                break;
              }

              error = errors.find(function (e) {
                return e.type === 'numFiles';
              });
              setErrorStatus(true);
              setMessageToShow(error.message(maxNumFiles));
              return _context.abrupt("return");

            case 7:
              _context.next = 9;
              return Promise.all(Array.prototype.map.call(files, readAsDataURL)).then(function (imgs) {
                onImagesLoad(imgs);
              }).catch(function (error) {
                setErrorToShow([error]);
              });

            case 9:
              setMessageToShow(descriptionMessage);

              if (!(erroredImages && erroredImages.length > 0)) {
                _context.next = 16;
                break;
              }

              errorMessages = createErrorMessages();
              setErrorStatus(true);
              setErrorToShow(errorMessages);
              setErroredImages([]);
              return _context.abrupt("return");

            case 16:
              resetErrorStatus();
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](1);
              resetErrorStatus();
              setMessageToShow(_context.t0.message);

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 19]]);
    }));

    return function handleImages(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    setLoading(loading);
  }, [loading]);
  return _react.default.createElement(_styles.UploaderDragStyled, {
    key: dropRef,
    ref: dropRef,
    hasError: hasError || errorStatus,
    position: "relative",
    borderRadius: 2,
    size: size,
    backgroundColor: draggin && 'coco' || 'ghosted.copoazu.light',
    borderWidth: draggin && '1px',
    borderStyle: draggin && 'dotted',
    borderColor: draggin && 'guijarro',
    alignItems: "center",
    flexDirection: "column",
    draggable: true,
    onDrop: function onDrop(e) {
      var _e$dataTransfer$files;

      e.preventDefault();
      e.stopPropagation();
      setDraggin(false);

      if (((_e$dataTransfer$files = e.dataTransfer.files) === null || _e$dataTransfer$files === void 0 ? void 0 : _e$dataTransfer$files.length) > 0) {
        var files = e.dataTransfer.files;
        handleImages(files);
        inputRef.current.files = e.dataTransfer.files;
        setDragCounter(0);
      }
    },
    onDragEnter: function onDragEnter(e) {
      var _e$dataTransfer$items;

      e.preventDefault();
      e.stopPropagation();
      setDragCounter(dragCounter + 1);

      if (((_e$dataTransfer$items = e.dataTransfer.items) === null || _e$dataTransfer$items === void 0 ? void 0 : _e$dataTransfer$items.length) > 0) {
        setDraggin(true);
      }
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    onDragLeave: function onDragLeave(e) {
      e.preventDefault();
      e.stopPropagation();
      setDragCounter(dragCounter - 1);

      if (dragCounter === 0) {
        setDraggin(false);
      }
    }
  }, !isLoading && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Icon.Icon, {
    color: "langsat",
    size: ['huge', 'huge', 'gigantic']
  }, _react.default.createElement(_Icons.CloudUpload, null)), _react.default.createElement(_Typography.TextForm, {
    size: "medium",
    color: "guijarro",
    marginTop: 3,
    textAlign: "center"
  }, draggin ? _react.default.createElement(_react.default.Fragment, null, messageToShow || 'Suelta las imágenes para empezar a cargarlas') : _react.default.createElement(_react.default.Fragment, null, messageToShow)), _react.default.createElement(_Typography.TextForm, {
    size: "micro",
    color: hasError ? 'rambutan' : 'guijarro',
    marginTop: 3,
    textAlign: "center"
  }, maxUploadSizeMessage)), isLoading && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_styles.UploaderThumbnailStyled, {
    ref: canvasRef
  }), _react.default.createElement(_Layout.Flex, {
    zIndex: 0,
    flexDirection: "column",
    padding: 6,
    width: "100%",
    alignItems: "center"
  }, _react.default.createElement(_ProgressBar.ProgressBar, {
    percent: progressNumber,
    size: "small",
    progressBarColor: "ghosted.coco.lighter",
    progressBarValueColor: "coco"
  }), _react.default.createElement(_Typography.TextForm, {
    size: "medium",
    color: "coco",
    marginTop: 7,
    zIndex: 0,
    textAlign: "center"
  }, progressMessage))), _react.default.createElement(_styles.UploaderInputStyled, {
    ref: inputRef,
    multiple: multiple,
    type: "file",
    accept: "image/*",
    max: maxNumFiles,
    onChange: function onChange(e) {
      var files = (0, _toConsumableArray2.default)(e.target.files);

      _onChange((0, _toConsumableArray2.default)(e.target.files));

      handleImages(files);
    },
    id: name,
    name: name,
    required: required
  }), errorToShow === null || errorToShow === void 0 ? void 0 : errorToShow.map(function (error) {
    return _react.default.createElement(Form.Error, null, error);
  }));
};

Form.Uploader.propTypes = {
  maxUploadSizeMessage: _propTypes2.default.string,
  maxNumFiles: _propTypes2.default.number,
  descriptionMessage: _propTypes2.default.string,
  progressMessage: _propTypes2.default.string,
  hasError: _propTypes2.default.bool,
  progressNumber: _propTypes2.default.number,
  multiple: _propTypes2.default.bool,
  size: _propTypes2.default.oneOf(['small', 'large']),
  onImagesLoad: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  errors: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['size', 'numFiles', 'wrongType', 'dimensions.width', 'dimensions.height', 'dimensions.width_and_height']),
    message: _propTypes2.default.func
  })),
  loading: _propTypes2.default.bool,
  minWidth: _propTypes2.default.number,
  minHeight: _propTypes2.default.number
};
Form.Uploader.defaultProps = {
  maxUploadSizeMessage: 'Tamaño máximo por imagen: 10mb',
  maxNumFiles: 15,
  descriptionMessage: 'Puedes arrastrar aquí hasta 15 imágenes',
  progressMessage: 'Cargando tus imágenes...',
  hasError: false,
  progressNumber: 69,
  multiple: false,
  size: 'small',
  onImagesLoad: function onImagesLoad() {},
  onChange: function onChange() {},
  loading: false,
  minWidth: 0,
  minHeight: 0
};

Form.ContentImage = function (props) {
  var id = props.id,
      src = props.src,
      external = props.external,
      name = props.name,
      placeholderMessage = props.placeholderMessage,
      sortableMode = props.sortableMode,
      noCaption = props.noCaption,
      aspectRatio = props.aspectRatio;
  return _react.default.createElement(_Layout.Box, {
    height: sortableMode ? '100px' : 'auto',
    overflow: "hidden"
  }, _react.default.createElement(_Image.Image, {
    src: src,
    external: external,
    alt: name,
    fluid: {
      maxWidth: 1440,
      aspectRatio: aspectRatio
    },
    imgStyle: sortableMode && {
      transform: 'translateY(-50%)'
    }
  }), !noCaption && _react.default.createElement(Form.Input, (0, _extends2.default)({
    name: id,
    id: id,
    borderless: true,
    size: "small",
    textAlign: "center",
    placeholder: placeholderMessage
  }, props)));
};

Form.ContentImage.propTypes = {
  id: _propTypes2.default.string.isRequired,
  src: _propTypes2.default.string.isRequired,
  external: _propTypes2.default.bool,
  name: _propTypes2.default.string,
  placeholderMessage: _propTypes2.default.string,
  sortableMode: _propTypes2.default.bool,
  noCaption: _propTypes2.default.bool,
  aspectRatio: _propTypes2.default.number
};
Form.ContentImage.defaultProps = {
  external: false,
  name: '',
  placeholderMessage: 'Escribe aquí un pie de imagen (opcional)',
  sortableMode: false,
  noCaption: false,
  aspectRatio: null
};
var RemoveIconStyled = (0, _styledComponents.default)(_Icon.Icon).withConfig({
  displayName: "Form__RemoveIconStyled",
  componentId: "sc-1jnx13u-0"
})({
  cursor: 'pointer'
});

Form.RemoveItemWrapper = function (props) {
  var children = props.children,
      id = props.id,
      action = props.action,
      isMobile = props.isMobile;

  var _React$useState19 = _react.default.useState(false),
      _React$useState20 = (0, _slicedToArray2.default)(_React$useState19, 2),
      isMouseOver = _React$useState20[0],
      setIsMouseOver = _React$useState20[1];

  var setMouseOver = function setMouseOver() {
    setIsMouseOver(true);
  };

  var setMouseLeave = function setMouseLeave() {
    setIsMouseOver(false);
  };

  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Box, {
    position: "relative",
    key: id,
    id: id,
    onMouseOver: setMouseOver,
    onMouseLeave: setMouseLeave,
    onFocus: function onFocus() {
      return undefined;
    },
    onBlur: function onBlur() {
      return undefined;
    }
  }, (isMouseOver || isMobile) && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Layout.Flex, {
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 9,
    padding: 3
  }, _react.default.createElement(_Layout.Box, {
    key: "".concat(id, "CloseButtonBackground"),
    id: "".concat(id, "CloseButtonBackground"),
    backgroundColor: "sonar",
    width: "42px",
    height: "42px",
    borderRadius: 7,
    opacity: 1,
    onClick: action
  })), _react.default.createElement(_Layout.Flex, {
    position: "absolute",
    right: 0,
    top: 0,
    zIndex: 10,
    padding: 3
  }, _react.default.createElement(_Layout.Box, {
    key: "".concat(id, "CloseButton"),
    id: "".concat(id, "CloseButton"),
    borderRadius: 7,
    padding: 3,
    marginLeft: 3,
    onClick: action
  }, _react.default.createElement(RemoveIconStyled, {
    size: "small",
    color: "coco"
  }, _react.default.createElement(_Icons.Trash, null))))), children));
};

Form.RemoveItemWrapper.propTypes = {
  id: _propTypes2.default.string.isRequired,
  action: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node.isRequired,
  isMobile: _propTypes2.default.bool
};
Form.RemoveItemWrapper.defaultProps = {
  isMobile: false
};

Form.MenuContentItem = function (props) {
  return _react.default.createElement(_MenuContentItem.MenuContentItem, props);
};

Form.Checkbox = function (props) {
  var id = props.id,
      name = props.name,
      value = props.value,
      label = props.label,
      size = props.size,
      disabled = props.disabled,
      checked = props.checked,
      hasError = props.hasError,
      onChange = props.onChange;

  var _React$useState21 = _react.default.useState(checked),
      _React$useState22 = (0, _slicedToArray2.default)(_React$useState21, 2),
      isChecked = _React$useState22[0],
      setChecked = _React$useState22[1];

  var toggleChecked = function toggleChecked() {
    setChecked(!isChecked);
    onChange(!isChecked);
  };

  return _react.default.createElement(_styles.CheckboxContainerStyled, {
    position: "relative",
    tabIndex: "-1",
    size: size
  }, _react.default.createElement(_styles.HiddenCheckboxStyled, {
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    disabled: disabled,
    checked: isChecked,
    onClick: toggleChecked,
    tabIndex: "-1",
    style: {
      cursor: disabled && 'not-allowed',
      boxShadow: disabled && 'none'
    }
  }), _react.default.createElement(_styles.CheckboxStyled, {
    disabled: disabled,
    checked: isChecked,
    hasError: hasError,
    size: size,
    borderRadius: 1,
    tabIndex: "0",
    style: {
      cursor: disabled && 'not-allowed',
      boxShadow: disabled && 'none'
    }
  }), _react.default.createElement(_styles.CheckboxLabelStyled, {
    size: size,
    hasError: hasError,
    tabIndex: "-1"
  }, label));
};

Form.Checkbox.propTypes = {
  id: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  label: _propTypes2.default.string,
  size: _propTypes2.default.string.isRequired,
  disabled: _propTypes2.default.bool,
  checked: _propTypes2.default.bool,
  hasError: _propTypes2.default.bool
};
Form.Checkbox.defaultProps = {
  label: null,
  disabled: false,
  checked: false,
  hasError: false
};